<template>
  <div class="main">
    <div class="project">
      <el-col :span="7">
        <el-input placeholder="请输入内容" v-model="keyWords" @keyup.enter.native="getListForMemberXcx" />
      </el-col>
      <el-button type="primary" icon="el-icon-search"></el-button>
      <div class="top1">或</div>
      <el-button type="primary" @click="publish(0)">免费发布项目</el-button>
    </div>
    <div class="projectType">
      <div v-for="(item, index ) in projectTypeList" :key="index" @click="switchType(item.projectTypeId)">
        <img :src="item.typeImg" alt="">
        <div :class="{ active: projectTypeId == item.projectTypeId, active1: projectTypeId != item.projectTypeId }">{{
          item.typeName }}</div>
      </div>
    </div>
    <div class="title">我的项目</div>
    <div class="projectList">
      <div class="projectItem" v-for="(item, index) in projectList" :key="index">
        <div class="left">
          <div>
            <img :src="item.image" alt="">
          </div>
          <div class="brief">
            <div>
              <div class="brief1">
                <div class="ellipsisTwo">{{ item.projectName }}</div>
                <img src="../../assets/img/safe.png" alt="">
              </div>
              <div class="brief2">
                <img src="../../assets/img/location.png" alt="">
                <div>{{ item.cityName }}</div>
              </div>
            </div>
            <div class="brief3" v-html="item.projectDescribe"></div>
            <div class="brief4"><span v-for="(item1, index1) in item.projectTag" :key="index1">{{ item1 }}</span></div>
          </div>
        </div>
        <div> {{ item.examineStatus == 0 ? '待审核' : item.examineStatus == 1 ? item.status == 0 ? '待开放' :
          item.status == 1 ? '开放中' : item.status == 2 ? '暂停中' : item.status == 3 ? '已关闭' : '' :
          item.examineStatus ==
            2 ? '审核驳回' : '' }}</div>
        <div class="projectImg">
          <div class="projectImg1">
            <img v-if="item.projectImage" :src="item.projectImage.split(',')[0]" alt="">
            <div>{{ item.name }}</div>
            <div>{{ item.salary }}元</div>
          </div>
          <div class="projectImg2">
            <div @click="edit(item.projectId, 1)" v-if="item.examineStatus != 2">编辑</div>
            <div @click="edit(item.projectId, 2)" v-if="item.examineStatus == 2">重发</div>
            <div @click="edit(item.projectId, 3)" v-if="item.examineStatus != 2">查看</div>
            <div v-if="item.status == 2" @click="editStatus(item.projectId, '1')">开放</div>
            <div v-if="item.status == 1" @click="editStatus(item.projectId, '2')">暂停</div>
            <div v-if="item.status != 3 && item.examineStatus == 1" @click="editStatus(item.projectId, '3')">关闭</div>
            <div @click="delPosition(item.projectId)">删除</div>

          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div>共{{ total }}个项目</div>
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageNum"
        layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <el-dialog inline :title="dialogTitle" :visible.sync="show" :close-on-click-modal="false" @close="closeDialog">
      <el-form :model="form" class="form1" :rules="rules" ref="form" label-width="100px"
        :disabled="addOrEdit == 'check'">
        <el-form-item label="项目名称" prop="projectName">
          <el-input v-model="form.projectName" placeholder="请输入项目标题"></el-input>
        </el-form-item>
        <el-form-item label="项目类型" prop="projectTypeId">
          <el-select v-model="form.projectTypeId" placeholder="请选择项目类型" style="width: 100%" clearable>
            <el-option :label="item.typeName" :value="item.projectTypeId" v-for="(item, index) in projectTypeListAdd"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目标签" prop="projectTag">
          <el-select v-model="form.projectTag" placeholder="请选择项目标签" multiple style="width: 100%" clearable>
            <el-option :label="item.tagName" :value="item.tagName" v-for="(item, index) in tagList"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算方式" prop="settlementMethod">
          <el-select v-model="form.settlementMethod" placeholder="请选择结算方式" style="width: 100%" clearable>
            <el-option :label="item.paramName" :value="item.paramName" v-for="(item, index) in settlement_method"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="薪资" prop="salary">
          <el-input v-model="form.salary" type="number" min="0" step="100" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contactPhone">
          <el-input v-model="form.contactPhone" placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="工作地点" prop="region">
          <el-cascader v-model="form.region" :options="regionTreeList" :props="{ value: 'label' }"
            @change="changeRegion" style="width: 100%;" clearable />
        </el-form-item>
        <el-form-item label="详细地址" prop="workAddress">
          <el-input v-model="form.workAddress" placeholder="请选择详细地址" @focus="setAddress"></el-input>
        </el-form-item>
        <el-form-item label="项目描述" prop="projectDescribe">
          <rich-text v-model="form.projectDescribe" v-if="addOrEdit != 'check'" :placeholder="'请输入项目描述'" />
          <div style="word-break: break-all;
  white-space: pre-line;" v-html="form.projectDescribe" v-if="addOrEdit == 'check'"></div>
        </el-form-item>
        <el-form-item label="项目要求" prop="projectRequire">
          <rich-text v-model="form.projectRequire" v-if="addOrEdit != 'check'" :placeholder="'请输入项目要求'" />
          <div style="word-break: break-all;
  white-space: pre-line;" v-html="form.projectRequire" v-if="addOrEdit == 'check'"></div>
        </el-form-item>
        <el-form-item label="其他说明" prop="otherIllustrate">
          <rich-text v-model="form.otherIllustrate" v-if="addOrEdit != 'check'" :placeholder="'请输入其他说明'" />
          <div style="word-break: break-all;
  white-space: pre-line;" v-html="form.otherIllustrate" v-if="addOrEdit == 'check'"></div>
        </el-form-item>
        <el-form-item label="项目图片" prop="projectImage">
          <image-upload v-model="form.projectImage" :limit="3" :disabled="addOrEdit == 'check'"></image-upload>
        </el-form-item>
      </el-form>
      <div class="text">项目发布后，项目类别不可修改，但您仍可在服务方接单前修改其他信息。
        发布项目即表示同意遵守<span style="color: #0051AA;cursor: pointer;" @click="pushRule">《项目订单发布规则》</span></div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogFormVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="submit" :disabled="addOrEdit == 'check'">免费发布</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showMap" class="mapDialog">
      <iframe id="mapPage" width="100%" height="500px" frameborder=0
      :src="`https://apis.map.qq.com/tools/locpicker?coord=${coord}?search=1&type=1&key=RGEBZ-ARFKN-7NRF5-SNH73-OUVK3-KEBE7&referer=刘湾零工市场'`"">
      </iframe>
    </el-dialog>

    <el-dialog :visible.sync="showText" :title="project_order_release_rules.ruleTitle" class="qrcodeDialog" width="500px">
      <div v-html="project_order_release_rules ? project_order_release_rules.ruleContent : ''">
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageNum: 1,
      total: 0,
      projectTypeList: [],
      projectList: [],
      projectTypeId: '',
      keyWords: '',
      show: false,
      showMap: false,
      salary_range: [],
      settlement_method: [],
      tagList: [],
      positionTypeList: [],
      form: {
        projectName: '',
        salary: '',
        settlementMethod: '',
        projectTypeId: '',
        provinceName: '',
        cityName: '',
        areaName: '',
        workAddress: '',
        longitude: '',
        latitude: '',
        contactPhone: '',
        projectDescribe: '',
        projectRequire: '',
        otherIllustrate: '',
        projectImage: '',
        projectTag: [],
        region: [],
      },
      rules: {
        projectName: [
          { required: true, message: '请输入项目标题', trigger: 'blur' },
        ],
        projectTypeId: [
          { required: true, message: '请选择项目类型', trigger: 'change' },
        ],
        projectTag: [
          { required: true, message: '请选择项目标签', trigger: 'change' },
        ],
        settlementMethod: [
          { required: true, message: '请选择结算方式', trigger: 'change' },
        ],
        salary: [
          { required: true, message: '请输入薪资', trigger: 'blur' },
        ],
        contactPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { max: 11, message: "手机号长度为11位", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号", trigger: "blur" },
        ],
        projectDescribe: [
          { required: true, message: '请输入项目描述', trigger: 'blur' },
        ],
        projectRequire: [
          { required: true, message: '请输入项目要求', trigger: 'blur' },
        ],
        region: [
          { required: true, message: '请选择工作地点', trigger: 'blur' },
        ],
        workAddress: [
          { required: true, message: '请选择详细地址', trigger: 'change' },
        ],
        otherIllustrate: [
          { required: true, message: '请输入其他说明', trigger: 'blur' },
        ],
        projectImage: [
          { required: true, message: '请选择项目图片', trigger: 'change' },
        ],
      },
      regionTreeList: [],
      submitType: 0,
      addOrEdit: '',
      projectTypeListAdd: [],
      dialogTitle: '',
      coord:'',
      showText:false,
      project_order_release_rules:''
    }
  },
  mounted() {
    this.getProjectTypeList()
    this.getListForMemberXcx()
    // this.getPositionListByPid1()
    this.selectTagList()
    this.getDictParamList()
    this.selectRegionTreeList()
    let that = this
    window.addEventListener('message', function (event) {
      // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
      var loc = event.data;
      if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
        // console.log('location', loc);
        that.form.longitude = loc.latlng.lng
        that.form.latitude = loc.latlng.lat
        // that.form.workAddress = loc.poiaddress
        that.form.workAddress = loc.poiname
        that.showMap = false
      }
    }, false);
  },
  methods: {
    pushRule(){
      // this.changeRegion()
      this.showText = true
      this.$get("/api/common/selectRuleByType", {
        ruleType: 'project_order_release_rules',
      }).then((res) => {
        this.project_order_release_rules = res.data
      });
    },

    closeDialog() {
      this.coord = ''
      this.$refs.form.resetFields()
    },

    setAddress() {
      if (this.coord) {
      this.showMap = true
      }else{
        this.$message({
            message: '请先选择工作地点',
            type: 'warning'
          })
      }
    },
    publish(type) {
      this.addOrEdit = 'add'
      this.dialogTitle = '发布项目'
      this.form = {
        projectName: '',
        salary: '',
        settlementMethod: '',
        projectTypeId: '',
        provinceName: '',
        cityName: '',
        areaName: '',
        workAddress: '',
        longitude: '',
        latitude: '',
        contactPhone: '',
        projectDescribe: '',
        projectRequire: '',
        otherIllustrate: '',
        projectImage: '',
        projectTag: [],
        region: [],
      },
        this.show = true
      setTimeout(() => {
        this.$refs.form.resetFields()
      }, 200);
      this.submitType = type
    },
    editStatus(id, status) {
      this.$post("/api/company/project/projectStatusEdit", {
        projectId: id,
        status
      }).then((res) => {
        this.$message({
          message: '状态修改成功',
          type: 'success'
        });
        this.getListForMemberXcx()
      });
    },
    delPosition(id) {
      this.$confirm('此操作将删除该项目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("/api/company/project/projectDelete", {
          projectId: id
        }).then((res) => {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getListForMemberXcx()
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    edit(id, type) {
      this.addOrEdit = type == 1 ? 'edit' : type == 2 ? 'again' : type == 3 ? 'check' : ''
      this.dialogTitle = (this.addOrEdit == 'add' || this.addOrEdit == 'again') ? '发布项目' : this.addOrEdit == 'check' ? '查看项目' : this.addOrEdit == 'edit' ? '编辑项目' : ''
      this.$get("/api/company/project/getCompanyProjectInfo", {
        projectId: id,
      }).then((res) => {
        this.show = true
        setTimeout(()=>{
          this.form = res.data
        this.form.projectTag = res.data.projectTag.split(',')
        this.form.region = []
        this.form.region[0] = res.data.provinceName?res.data.provinceName.replace('市', ''):''
        this.form.region[1] = res.data.cityName
        this.form.region[2] = res.data.areaName
        this.submitType = type
        this.coord = res.data.latitude + ',' +res.data.longitude

        },300)
      });
    },
    submit() {
      console.log(this.form)
      this.form.projectTag = this.form.projectTag.join(',')
      let that = this
      that.$refs.form.validate(valid => {
        if (valid) {
          if (that.form.projectId && that.submitType == 1) {
            that.$post('/api/company/project/projectEdit', {
              ...that.form
            }).then(res => {
              if (res.code == 200) {
                that.show = false
                that.$message({
                  message: '项目修改成功',
                  type: 'success'
                })
                that.getListForMemberXcx()
              }
            })
          } else if (that.submitType == 0 || that.submitType == 2) {
            that.$post('/api/company/project/projectRelease', {
              ...that.form
            }).then(res => {
              if (res.code == 200) {
                that.show = false
                that.$message({
                  message: '项目添加成功',
                  type: 'success'
                })
                that.getListForMemberXcx()
              }
            })
          }
        }
      })
    },
    selectRegionTreeList() {
      this.$get('/api/common/selectRegionTreeList', {}).then(res => {
        this.regionTreeList = res.data
      })
    },
    async changeRegion(value) {
      this.form.provinceName = value[0]
      this.form.cityName = value[1]
      this.form.areaName = value[2]
      let addressStr = value.join('')
      let res = await this.$jsonp(
        `https://apis.map.qq.com/ws/geocoder/v1`,
        {
          address: addressStr,
          key: "OO5BZ-Z7V6L-XFDP4-MPR6O-OD2XO-QPFVO", // 你的key
          type: 1,
          output: "jsonp",
        }
      );
      if (res.status === 0) {
        this.coord = res.result.location.lat + ',' +res.result.location.lng
      }
    },

    getDictParamList() {
      this.$get("/api/common/getDictParamList", {
        paramType: 'settlement_method',
      }).then((res) => {
        this.settlement_method = res.data
      });
      this.$get("/api/common/getDictParamList", {
        paramType: 'salary_range',
      }).then((res) => {
        this.salary_range = res.data
      });
    },
    selectTagList() {
      this.$get("/api/common/selectTagList", {
        tagType: 1,
      }).then((res) => {
        this.tagList = res.data
      });
    },
    // getPositionListByPid1() {
    //   this.$get("/api/company/position/getPositionListByPid", {
    //     pid: "0",
    //   }).then((res) => {
    //     let arr = [];
    //     res.data.forEach((v) => {
    //       let small = {
    //         value: v.positionTypeId,
    //         label: v.typeName,
    //         children: []
    //       };
    //       arr.push(small)
    //     });
    //     arr = arr.map(v => {
    //       this.$get("/api/company/position/getPositionListByPid", {
    //         pid: v.value,
    //       }).then(res => {
    //         if (v.value == res.data[0].pid) {
    //           let arr1 = [];
    //           res.data.forEach((v) => {
    //             let small = {
    //               value: v.positionTypeId,
    //               label: v.typeName,
    //             };
    //             arr1.push(small)
    //           });
    //           v.children = arr1
    //         }
    //       })
    //       return v
    //     })
    //     this.positionTypeList = arr;
    //   });
    // },
    getProjectTypeList() {
      this.$get('/api/company/project/getProjectTypeList', {}).then(res => {
        this.projectTypeListAdd = res.data
        let arr = JSON.parse(JSON.stringify(res.data))
        arr.unshift({
          projectTypeId: '0',
          typeImg: arr[2].typeImg,
          typeName: '全部'
        })
        this.projectTypeList = arr
      })
    },
    handleCurrentChange(value) {
      this.pageNum = value
      this.getListForMemberXcx()
    },
    switchType(id) {
      this.projectTypeId = id
      this.getListForMemberXcx()
    },
    getListForMemberXcx() {
      this.$get('/api/company/project/getCompanyProjectList', {
        projectTypeId: this.projectTypeId !== '0' ? this.projectTypeId : '',
        keyWords: this.keyWords,
        pageNum: this.pageNum,
        pageSize: 10
      }).then(res => {
        res.data.list.forEach(v => {
          v.projectTag = v.projectTag.split(',')
        })
        this.projectList = res.data.list
        this.total = res.data.total
      })
    }
  }
}
</script>
<style scoped>
.form1 {
  /* width: 800px; */
  text-decoration: none;
}

.dialog-footer {
  width: 100%;
  display: flex;
  justify-content: center;
}

.text {
  margin-left: 140px;
  width: 396px;
  height: 39px;
  font-family: PingFangSC-Regular, PingFangSC-Regular;
  font-weight: normal;
  font-size: 12px;
  color: #222222;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.main {
  padding: 30px;
}

.project {
  display: flex;
  justify-content: center;
  align-items: center;
}

.top1 {
  width: 50px;
  height: 50px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  line-height: 50px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.projectType {
  margin-top: 90px;
  display: flex;
  justify-content: center;
}

.projectType>div {
  margin-right: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.projectType>div>img {
  width: 40px;
  height: 40px;
}

.projectType>div>div {
  height: 22px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  line-height: 34px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.active {
  color: #0051AA;
}

.active1 {
  color: #29344D;
}

.title {
  width: 72px;
  height: 25px;
  margin-bottom: 20px;
  padding-left: 6px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 18px;
  color: #0051AA;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  border-left: 4px solid #0051AA;
}

.projectList {
  margin-bottom: 30px;
}

.projectItem {
  padding: 20px 0;
  /* height: 170px; */
  background: #FFFFFF;
  border-radius: 6px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left {
  /* width: 500px; */
  display: flex;
  align-items: center;
}

.left>div:nth-of-type(1) {
  width: 46px;
  height: 46px;
  margin-left: 30px;
}

.left>div:nth-of-type(1)>img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.brief {
  margin-left: 30px;
}

.brief>div:nth-of-type(1) {
  display: flex;
  justify-content: space-between;
}

.brief1 {
  display: flex;
  align-items: center;
}

.brief1>div {
  width: 350px;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.brief1>img {
  width: 15px;
  height: 18px;
  margin-left: 10px;
}

.brief2 {
  display: flex;
  align-items: center;
}

.brief2>div {
  height: 30px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #0051AA;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.brief2>img {
  width: 15px;
  height: 18px;
  margin-right: 10px;
}

.brief3 {
  width: 500px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #333333;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  word-break: break-all
}

.brief4>span {
  width: 60px;
  height: 20px;
  display: inline-block;
  margin-right: 10px;
  background: #F0F2F6;
  border-radius: 2px 2px 2px 2px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 10px;
  color: #555555;
  line-height: 22px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.projectImg {
  width: 600px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.projectImg1>img {
  width: 116px;
  height: 68px;
  background: #F5F7FB;
  border-radius: 4px;
  object-fit: cover;
}

.projectImg1>div:nth-of-type(1) {
  width: 120px;
  height: 17px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #333333;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.projectImg1>div:nth-of-type(2) {
  height: 17px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #0051AA;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.projectImg2 {
  display: flex;
  width: 300px;
  /* justify-content: space-around; */
  color: #0051AA;
  cursor: pointer;
}

.projectImg2>div {
  margin-right: 10px;
}

.footer {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>

<style>
.qrcodeDialog .el-dialog,
.el-dialog__wrapper .el-dialog {
  margin-top: 5vh !important;
}
</style>